import CalCalWPApi from './CalCalWPApi';
import AsyncStorage from '@react-native-async-storage/async-storage';

/*
This is taken out for web so as not to include the client_id and secret



*/

export default class AuthenticationApi {
	static async signIn(email: string, password: string, callBack) {
		//takes username, password. posts to get access and refresh tokens. returns
		const params = {
			grant_type: 'password',
			username: email,
			password: password
		};
		console.log('post auth');
		let result = await CalCalWPApi.post('oauth/authorize?oauth=token', params); //promise returned
		if (result) result.refreshTime = new Date().getTime() / 1000 + result.expires_in - 600;

		//if(result.access_token) saveUserAsync(result)
		if (__DEV__) console.log('result', result);

		callBack(result);
	}

	static async signUp(data, security, callBack) {
		//takes username, password. posts to get access and refresh tokens. returns
		if (__DEV__) console.log('sining up', data);
		let result = await CalCalWPApi.post('wp-admin/admin-ajax.php?action=register&security=' + security, data); //promise returned

		callBack(result);
	}

	static async preSignUp(callBack) {
		//takes username, password. posts to get access and refresh tokens. returns
		const formData = {};

		let result = await CalCalWPApi.post('wp-admin/admin-ajax.php?action=getregnonce', formData); //promise returned

		callBack(result);
	}

	static async refresh(user) {
		const params = {
			grant_type: 'refresh_token',
			refresh_token: user.refresh_token
		};

		let result = await CalCalWPApi.post('oauth/authorize?oauth=token', params); //promise returned
		result.refreshTime = new Date().getTime() / 1000 + result.expires_in - 600;
		return result;
	}

	static async fetchUserWP(user) {
		let result = await CalCalWPApi.get('/me/?access_token=' + user.access_token, params); //promise returned
		return result;
	}

	/*
  static async signUp(email: string, password: string) {


    return CalCalWPApi.post('/users', params);
  }

  static async isEmailTaken(email: string) {
    let response = await PlaygroundRestApi.get(`/validations/email/${email}`);
    return !response.available;
  }*/

	static async signOut() {
		//return CalCalWPApi.delete('/users/sign_out');
		////https://{server_url}/oauth/destroy?access_token={access_token}&refresh_token={refresh_token}
		return true;
	}
	/*
  static async isSignedIn() {
		const res = await AsyncStorage.getItem('@USER:refreshTime');
		var now = new Date().getTime()/1000;
		if (res !== null && res > now) {
			console.log('already signed in; ', res);
		  return(true);
		} else {
		  return(false);
		}
	}*/

	static async getUserAsync() {
		//needs refresh
		console.log('Need refresh');

		let result = await AuthenticationApi.refresh(user);
		if (__DEV__) console.log('refreshed', result);
		if (result.error) {
			return null;
		} else {
			user.access_token = result.access_token;
			user.refreshTime = result.refreshTime;
		}
		return user;
	}
}
